import { render, staticRenderFns } from "./PredefinedTourTable.vue?vue&type=template&id=6f2bb35e&scoped=true"
import script from "./PredefinedTourTable.vue?vue&type=script&lang=js"
export * from "./PredefinedTourTable.vue?vue&type=script&lang=js"
import style0 from "./PredefinedTourTable.vue?vue&type=style&index=0&id=6f2bb35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2bb35e",
  null
  
)

export default component.exports